import { components } from "@certn/api/generated-schemas/client-portal";
import { Card, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { CaseCard } from "../../../components/case-card/CaseCard";
import { RescreenCaseCard } from "../../../components/case-card/RescreenCaseCard";

interface CaseHistoryCardProps {
  cases?: readonly components["schemas"]["PeopleProfileCaseDetails"][];
  rescreenCases?: readonly components["schemas"]["PersonScheduledRescreens"][];
  viewCase: (arg0: string) => void;
  refreshData: () => void;
}

export function CaseHistoryCard({
  cases = [],
  rescreenCases,
  viewCase,
  refreshData,
}: CaseHistoryCardProps) {
  const { t } = useTranslation();

  return (
    <>
      <Card
        className={styles.cardContainer}
        type="large"
        responsive
        testID="case-history-card"
      >
        {rescreenCases && rescreenCases?.length > 0 && (
          <div className={styles.backgroundChecks}>
            <Text testID="rescreen-title" style="global/heading-large">
              {t("Rescreen")}
            </Text>
            {rescreenCases?.map((caseItem) => {
              return (
                <RescreenCaseCard
                  caseID={caseItem.short_id}
                  subtitle={caseItem.customer_group_name}
                  scheduledDate={caseItem.scheduled_date}
                  tags={caseItem.tags}
                  checks={caseItem.checks}
                  rescreenFrequency={caseItem.rescreen_frequency}
                  key={caseItem.short_id}
                  refreshData={refreshData}
                />
              );
            })}
          </div>
        )}
        <div className={styles.backgroundChecks}>
          <Text testID="background-checks-title" style="global/heading-large">
            {t("Background checks")}
          </Text>
          <div className={styles.caseCards}>
            {cases.length > 0 ? (
              cases?.map((caseItem) => {
                return (
                  <CaseCard
                    caseID={caseItem.short_id}
                    subtitle={caseItem.customer_group_name}
                    linkedCases={caseItem.linked_cases}
                    status={caseItem.overall_status}
                    decision={caseItem.decision}
                    score={caseItem.overall_score}
                    orderedDate={caseItem.created}
                    tags={caseItem.tags}
                    checks={caseItem.checks}
                    credentialRequest={caseItem.credential_request}
                    positionLocation={caseItem.position_location}
                    onViewCase={viewCase}
                    key={caseItem.short_id}
                    rescreenFrequency={caseItem.rescreen_frequency}
                    refreshData={refreshData}
                  />
                );
              })
            ) : (
              <Text testID="empty-case-label">
                {t("There are no cases yet.")}
              </Text>
            )}
          </div>
        </div>
      </Card>
    </>
  );
}

const styles = {
  cardContainer: css({
    display: "flex",
    flexDirection: "column",
    padding: `${"var(--space-5)"} ${"var(--space-4)"}`,
    gap: "var(--space-8);",
  }),
  backgroundChecks: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
  }),
  caseCards: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-3)",
  }),
  credentials: css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
  }),
};
